export function profileHashtags(value) {
  return (Array.isArray(value) ? value.join(' ') : String(value ?? '')).split(/[\s,]+/).map(tag => tag.replace(/^#+/, '')).filter(Boolean).map(tag => '#' + tag).join(' ');
}
